<template>
  <div class="ny">
    <div class="main">
      <div class="ny_bt1 mh md40">
        <span class="bt left">详情介绍</span>
      </div>
      <h2 class="mh md20 sbt">{{gs_data.Title}}</h2>
      <h5 class="mh md30 fbt">“儿童肝脏移植资助项目（非亲体）”于{{gs_data.Times}}经讨论一致通过对如下患者进行资助，现公示如下：</h5>
      <ul class="pros_lb1 md40">
          <li>
               <span class="s_name">时间</span>
               <p>{{gs_data.AddTime}}</p>
          </li>
          <li>
               <span class="s_name">地点</span>
               <p>{{gs_data.Address}}</p>
          </li>
          <li>
               <span class="s_name">提交患者数</span>
               <p>{{gs_data.PatientNum}}</p>
          </li>
      </ul>
      <div class="mh ta_k md50">
                 <el-table :data="tableData" border style="width:1200px;" >
                    <el-table-column prop="ApplyId" label="编号" width="90">
                    </el-table-column>
                     <el-table-column label="受者">
                          <el-table-column prop="PatientName" label="患者姓名" width="150">
                          </el-table-column>
                          <el-table-column prop="Gender" label="性别" width="90">
                          </el-table-column>
                          <el-table-column prop="Age" label="年龄" width="90">
                          </el-table-column>
                          <el-table-column prop="Illness" label="疾病" width="220">
                          </el-table-column>
                          <el-table-column label="资助与否" width="120">
                            <template slot-scope="scope">
                              是
                            </template>
                          </el-table-column>

                     </el-table-column>
                     <el-table-column label="供者">
                          <el-table-column prop="TransplantName" label="供者姓名" width="150">
                          </el-table-column>
                          <el-table-column prop="TransplantGender" label="性别" width="90">
                          </el-table-column>
                          <el-table-column prop="TransplantAge" label="年龄" width="90">
                          </el-table-column>
                          <el-table-column label="资助与否" width="120">
                            <template slot-scope="scope">
                              是
                            </template>
                          </el-table-column>
                     </el-table-column>

                </el-table>
      </div>
         <div class="suc_anq mh">
        <el-button type="primary" @click="$router.back(-1)">返回</el-button>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import http from "../http/http";
import api from "../http/api";
export default {
  data() {
    return {
       tableData: [],
       gs_data:[],
    };
  },
    mounted() {
    //加载详细
    this.DetailData();
  },
  methods: {
    //详细
  DetailData: async function () {
      let params = {
        NoticeId:this.$route.query.NoticeId ,
      }
      const res = await http.get(api.apigetnoticedetail, params)
      // this.gslist=res.data.obj;
      //  console.log(res.data.obj);
      this.gs_data=res.data.obj.ProjectNotice;
      this.tableData=res.data.obj.DetailList;
      // console.log(this.gs_data);
      // console.log(this.tableData);
    },
   },
  created: function () {
    // this.$emit('header', false);
  },

};
</script>

<style>
  .el-table--border th, .el-table__fixed-right-patch {
    /*border-color: #ddd;*/
  }
</style>



// WEBPACK FOOTER //
// src/page/pro_info.vue